import * as React from 'react'
import Box from '@mui/material/Box'
import SpeedDial from '@mui/material/SpeedDial'
import SpeedDialIcon from '@mui/material/SpeedDialIcon'
import SpeedDialAction from '@mui/material/SpeedDialAction'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import SmsIcon from '@mui/icons-material/Sms'
import AbcIcon from '@mui/icons-material/Abc'
import MessageIcon from '@mui/icons-material/Message'
import QueueIcon from '@mui/icons-material/Queue'
import TagIcon from '@mui/icons-material/Tag'
import EventIcon from '@mui/icons-material/Event'
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement'

import { DialogContext } from '../context/DialogContext.js'

export default function AddButtonLanguage() {
  const { dialogStates, openDialog, closeDialog } = React.useContext(DialogContext)

  const actions = [
    // { icon: <QuestionAnswerIcon />, name: 'Conversation', onClick: () => openDialog('dialogAddConversation') },
    // { icon: <MessageIcon />, name: 'Monologue' },
    { icon: <SmsIcon />, name: 'Sentence', onClick: () => openDialog('dialogAddSentence') },
    { icon: <QuestionAnswerIcon />, name: 'Inspiration', onClick: () => openDialog('dialogAddInspiration') },
    { icon: <TagIcon />, name: 'Consumption', onClick: () => openDialog('dialogAddConsumption') },
    { icon: <SmsIcon/>, name: 'Translate to all', onClick: () => openDialog('dialogAddSentenceAllTranslations') },
    { icon: <QueueIcon />, name: 'Sentences (Bulk)', onClick: () => openDialog('dialogAddSentencesExcel') },
    { icon: <EventIcon />, name: 'Meeting Documents', onClick: () => openDialog('dialogAddMeetingDocument') },
    { icon: <SelfImprovementIcon />, name: 'Journal Entry', onClick: () => openDialog('dialogAddJournal') }
    // { icon: <AbcIcon />, name: 'Word', onClick: () => openDialog('dialogAddWord') }
  ]

  return (
    <SpeedDial direction="up" ariaLabel="SpeedDialLanguage" icon={<SpeedDialIcon />}>
      {actions.map((action) => (
        <SpeedDialAction key={action.name} icon={action.icon} tooltipTitle={action.name} onClick={action.onClick} />
      ))}
    </SpeedDial>
  )
}
